var map = {
	"./birds.svg": 393,
	"./boat.svg": 150,
	"./city.svg": 628,
	"./coffee-shop.svg": 916,
	"./fireplace.svg": 665,
	"./pink-noise.svg": 407,
	"./rain.svg": 336,
	"./sound-wave.svg": 165,
	"./storm.svg": 584,
	"./stream.svg": 597,
	"./summer-night.svg": 441,
	"./train.svg": 993,
	"./waves.svg": 327,
	"./white-noise.svg": 189,
	"./wind.svg": 259
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75;